import { render, staticRenderFns } from "./qualityScorecard.vue?vue&type=template&id=9ec92434&scoped=true"
import script from "./qualityScorecard.vue?vue&type=script&lang=js"
export * from "./qualityScorecard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec92434",
  null
  
)

export default component.exports